// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 635 ? "vuetify" : chunkId) + "." + {"83":"bd32b820","97":"37a79381","133":"f0bdc76f","159":"25a6e6d7","190":"ca650e7f","635":"2f726510","959":"07594163"}[chunkId] + ".css";
};